import type { ReduxBaseStateInterface } from '@/types/component';
import createTransform from 'redux-persist/es/createTransform';
// to reset temporary states like loading, error, message, cached
export const transform = createTransform(
  (inboundState: ReduxBaseStateInterface<unknown>) => {
    const convertedInbound: ReduxBaseStateInterface<unknown> = {
      data: inboundState?.data,
      loading: false,
      error: false,
      message: '',
      cached: false,
    };
    if ('userPermissions' in inboundState && inboundState?.userPermissions) {
      // @ts-expect-error for saving user-permissions
      convertedInbound.userPermissions = inboundState?.userPermissions;
    }
    return convertedInbound;
  },
  (outboundState) => {
    return outboundState;
  },
);

export const expireTransform = (expireSeconds: number, initialState: object) =>
  createTransform(
    // before saving to storage
    (inboundState) => ({
      ...(inboundState as object),
      _persistedAt: Date.now(),
    }),

    // when loading from storage
    (outboundState, key) => {
      //@ts-expect-error version exists sometimes
      if (!outboundState?._persistedAt || outboundState?.version)
        return outboundState;

      const isExpired =
        Date.now() - outboundState._persistedAt > expireSeconds * 1000;
      if (isExpired) {
        return initialState[key as keyof typeof initialState]; // clears the slice
      }

      return outboundState;
    },
  );
